import MasterCrudPage from "../../components/MasterCrudPage";
import { bankAccountTypeApi } from "../../api/masterApi";

export default function BankAccountType() {
  return (
    <MasterCrudPage
      title="Bank Account Type"
      description="Bank account types such as Saving, Current, NRO."
      idKey="bank_account_type_id"
      api={bankAccountTypeApi}
      listLabel="bank account types"
      useJson
      fields={[
        {
          name: "account_type",
          label: "Account Type",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "e.g. Saving, Current, NRO",
        },
      ]}
      columns={[
        { key: "bank_account_type_id", label: "Bank Account Type" },
        { key: "account_type", label: "Account Type" },
      ]}
    />
  );
}
